<div [class]="classefecto">
  <!-- Inicio card -->
  <div class="card border-success">
    <div *ngIf="header" class="card-header">
      <div id="paginacion">
                <span class="izquierda">
                    <h4><strong>{{titulo}}</strong></h4>
                </span>
        <span class="derecha">
                    <div *ngIf="banderaColapse">
                        <a (click)="cambiar()" data-bs-toggle="collapse" href="#{{colapseName}}">
                            <h1>{{this.simbolo}}</h1>
                        </a>
                    </div>
                    <app-lfsa-options (devolverAccion)="devolverAccionOption($event)"
                                      *ngIf="options"></app-lfsa-options>
                    <app-lfsa-options-export (devolverAccionExport)="devolverAccionOptionExport($event)"
                                             *ngIf="optionsExport"></app-lfsa-options-export>
                    <app-lfsa-option-export-portal-compras (devolverAccionExportPortal)="devolverAccionOptionExportPortal($event)"
                                                           *ngIf="optionsExportPortal"></app-lfsa-option-export-portal-compras>
                </span>
      </div>
    </div>
    <div aria-labelledby="headingOne" class="collapse show" data-parent="#accordionExample" id="{{colapseName}}">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="innTemplate">
          <ng-template #innTemplate>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div *ngIf="footer" class="card-footer text-muted">
      <ng-container *ngTemplateOutlet="innFooterTemplate">
        <ng-template #innFooterTemplate>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <!-- fin card -->
</div>
<br>
<!-- fin Container  -->
